module.exports = __webpack_public_path__ + "img/1557399823.6d5fd66b.jpg";